import { axiosAjax } from '@app/src/config/axios';
import { CategoryModel } from '@app/src/views/Home/listProducts';
import { hydrateData } from './hydrators';

export const serviceCategories = {
  async get(): Promise<CategoryModel[]> {
    try {
      const { data } = await axiosAjax.get(process.env.API_CATEGORY);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
